<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const tableCellVariants = cva('py-2 px-3 align-middle font-ui text-action-secondary-foreground text-ui-sm', {
  variants: {
    type: {
      normal: 'text-aside-secondary-foreground text-ui-sm',
      bold: 'text-aside-primary-foreground font-heading text-heading-2xs'
    }
  },
  defaultVariants: {
    type: 'normal'
  }
})

type LabelProps = VariantProps<typeof tableCellVariants>

defineProps<{
  type?: LabelProps['type'],
}>()

</script>

<template>
  <td :class="classMerge(tableCellVariants({type}), $attrs.class ?? '')">
    <div class="flex flex-col">
      <slot />
    </div>
  </td>
</template>
